import React from 'react';
import { Col, FormGroup, FormControl, ControlLabel, Button, Alert } from 'react-bootstrap';

const CommonFormField = ({ label, name, type, placeholder, handler }) => (
    <Col xs={12} md={6}>
        <FormGroup controlId={name}>               
            <ControlLabel>{label}</ControlLabel>
            <FormControl type={type} name={name}
            onChange={handler} placeholder={placeholder} required />
            <FormControl.Feedback />           
        </FormGroup>
    </Col>
);

const CommonFormButton = ({ handler, text, bsStyle }) => (   
    <Col xs={12} md={12} className="mt-md-1">
      <Button className={bsStyle} onClick={handler} block>
        {text}
      </Button>
    </Col> 
);

const CommonAlertBox = ({label, caption}) => (
    <Col xs={12} className="mt-md-2">
      <Alert bsStyle="warning">
        <strong>{label} </strong> 
        {caption}
      </Alert>
    </Col> 
  );

export { CommonFormField, CommonFormButton, CommonAlertBox };


// WEBPACK FOOTER //
// ./src/cmp/Authentication/CommonFields.js